export function getInnerOffset(hidden, hiddenTicks, tickPosition, primaryTickLength) {
    return hidden || hiddenTicks
        ? 0
        : getOffsetFromTickPosition(tickPosition, primaryTickLength);
}
function getOffsetFromTickPosition(tickPosition, primaryTickLength) {
    switch (tickPosition) {
        case 'outer':
            return 0;
        case 'inner':
            return primaryTickLength;
        case 'center':
            return primaryTickLength / 2;
        default:
            throw new Error('unreachable');
    }
}
//# sourceMappingURL=axis.js.map